import { disableScroll, hitPageView, banners } from "../utils/fn";
import { topsideBanner } from '../utils/adv-stroeer-gallery';

export let loadGallery = (args) => {
  let {arrayPhotos, galleryId, indexOf, $galleryList, onMobileOff, onMobileLandscapeOff, additionalParams} = args;
  
  let defaults = {
        dynamicGallery: false,
        selector: '',
        singleLoad: false,
      },
      options = Object.assign(defaults, additionalParams);

  window.history.pushState( {} , null, window.location.href );
  $(window).on('popstate', function() {
    $('.lg-close').trigger('click');
  });

  $galleryList.data('page-location', document.location.pathname);

  $galleryList.lightGallery({
      galleryId: galleryId || 1,
      selector: options.selector,
      dynamic: options.dynamicGallery,
      html: true,
      index: indexOf,
      dynamicEl: arrayPhotos || [],
      hideBarsDelay: 100000,
      thumbWidth: 142,
      thumbContHeight: 90,
      thumbMargin: 5,
      exThumbImage: 'data-thumb',
      closable: false,
      showThumbByDefault: onMobileLandscapeOff,
      autoplayControls: onMobileOff,
      zoom: true, //onMobileOff,
      fullScreen: false,
      download: !onMobileOff,
      customContentContainerCls: 'lg-custom-content-related',
      hash: false,
      topside: true,
      aside: true,
      additional: [
        {
          html: $('.shareBox')
            .first()
            .clone(true, true)
            .addClass('to-up')
            .removeClass('big-shareBox')
            .removeClass('to-down'),
          className: 'lg-additional-share',
        },
      ],
      topsideOnBeforeSlide: function(event, prevIndex, index) {
        // this.hide(); // hide dmpu in photo gallery
        var core = this.core.$items[index];
        let $this = this;

        if (core.htmlSlide) {
          this.hide();
          this.addMarkHtmlSlide();
        } else if (core.adSlide) {
          this.hide();
          // this.addMarkAdSlide();
        } else {
          this.hideMarkHtmlSlide();
          // this.hideMarkAdSlide();
          if (document.documentElement.clientWidth < 768) {
            if (document.documentElement.clientWidth <= 480) {
              if (!core.hor) {
                if(arrayPhotos == false) {
                  this.show();
                } else {
                  this.hide();
                }
              } else {
                this.show();
              }
            } else {
              this.hide();
            }
            // this.hide();
            // if(ActEachFiveSlide.params){
            //     if((index + 1)%5 == 0){
            //         var $banner = this.$boxWrapper.find('.apb.rectangle .ap');
            //         if($banner.length && !$banner.is(':empty')){
            //             $banner.removeAttr('data-ready').empty();
            //         }
            //         this.show();
            //     }else{
            //         this.hide();
            //     }
            // } else {
            //     if(index + 1 == 5){
            //         var $banner = this.$boxWrapper.find('.apb.rectangle .ap');
            //         if($banner.length && !$banner.is(':empty')){
            //             $banner.removeAttr('data-ready').empty();
            //         }
            //         this.show();
            //     }else{
            //         this.hide();
            //     }
            // }
          } else {
            this.show();
          }
        }

        if(core.adSlide) {
          this.addMarkAdSlide();
        } else {
          this.hideMarkAdSlide();
        }
      },
      topsideInit: function() {

        this.topsideOnAfterSlideTimeout = null;
        var $topside_banner = $('#ap_popup_gallery_top').find('.apb');
        if ($topside_banner.length) {
          this.$boxWrapper.append($topside_banner.clone(true));
        } else if ($('body').data('edtn') == 'de' || $('body').data('edtn') == 'ev_de') {
          this.$boxWrapper.append('<div class="stroer-ap"></div>');
        }
      },
      topsideOnAfterSlide: function(event, prevIndex, index) {
        var _this = this;
        function bannerInit() {
          if (_this.core.$outer.is('.lg-topside-off')) {
            return;
          }
          var $banner = _this.$boxWrapper.find('.ap');
          var $deBanner = _this.$boxWrapper.find('.stroer-ap');
          if ($banner.length) {
            $banner.removeAttr('data-ready').empty();
            banners(_this.$boxWrapper);
          } else if ($deBanner.length) {
            topsideBanner($deBanner, 'top');
          }
        }
        // function skinInit() {
        //   if (_this.core.$outer.is('.lg-topside-off')) {
        //     return;
        //   }
        //   var $skinHolder = _this.$boxWrapper.find('.skin-holder');
        //   var $banner = _this.$boxWrapper.find('.ap');
        //   if ($skinHolder.children().length > 0) {
        //     $skinHolder.children().remove();
        //     $skinHolder.removeAttr('data-init').empty();
        //   }
        // }
        clearTimeout(this.topsideOnAfterSlideTimeout);
        if (this.topsideOnAfterSlideTimeout === null) {
          bannerInit();
          // skinInit();
          this.topsideOnAfterSlideTimeout = 1;
        } else {
          this.topsideOnAfterSlideTimeout = setTimeout(bannerInit, 1000);
          // this.topsideOnAfterSlideTimeout = setTimeout(skinInit, 1000);
        }
      },
      topsideDestroy: function() {
        this.topsideOnAfterSlideTimeout = null;
      },
      asideDestroy: function() {
        this.asideOnAfterSlideTimeout = null;
      },
      asideInit: function() {
        this.asideOnAfterSlideTimeout = null;
        this.$boxWrapper.append(
          '<h2 class="asideTitle" style="display:none;"></h3>'
        );
        this.$boxWrapper.append(
          '<div class="asideCaption" style="display:none;"></div>'
        );
        var $shareBox = $('.shareBox')
          .first()
          .clone(true, true)
          .removeClass('big-shareBox');
        if ($shareBox.length) {
          this.$boxWrapper.append($shareBox);
        }

        var $aside_banner = $('#ap_popup_gallery_rectangle').find('.ap');
        if ($aside_banner.length) {
          this.$boxWrapper.append($aside_banner.clone());
        } else if ($('body').data('edtn') == 'de' || $('body').data('edtn') == 'ev_de') {
          this.$boxWrapper.append('<div class="stroer-ap"></div>');
        }
      },
      asideOnAfterSlide: function(event, prevIndex, index) {
        var _this = this;
        var $title = this.$boxWrapper.find('h2.asideTitle'),
          $caption = this.$boxWrapper.find('.asideCaption');
        if ($title && arrayPhotos) {
          let subHtml = arrayPhotos[index].subHtml;
          if (subHtml) {
            $title.show().html(subHtml);
          } else {
            let $h1 = $('h1');
            if ($h1.length) {
              $title.show().html($h1.text());
            } else {
              $title.hide();
            }
          }
          let captions = arrayPhotos[index].caption;
          let description = arrayPhotos[index].description;

          if (description || captions) {
            $caption.html(description || captions).show();
          } else {
            $caption.hide();
          }
        }
        if (document.documentElement.clientWidth < 1024) {
          return;
        }
        function bannerInit() {
          var $banner = _this.$boxWrapper.find('.ap');
          var $deBanner = _this.$boxWrapper.find('.stroer-ap');
          if ($banner.length) {
            $banner.removeAttr('data-ready').empty();
            banners(_this.$boxWrapper);
          } else if ($deBanner.length) {
            topsideBanner($deBanner, 'sidebar');
          }
        }
        clearTimeout(this.asideOnAfterSlideTimeout);
        if (this.asideOnAfterSlideTimeout === null) {
          bannerInit();
          this.asideOnAfterSlideTimeout = 1;
        } else {
          this.asideOnAfterSlideTimeout = setTimeout(bannerInit, 1000);
        }
      },
    })
    .on('onAfterSlide.lg', function(event) {
      disableScroll();
      var lightGalleryCore = $(this).data('lightGallery');
      if ('index' in lightGalleryCore) {
        var $currentSlide = $(
          lightGalleryCore.$items[lightGalleryCore.index]
        );
        if ($currentSlide.length) {
          var data = $currentSlide[0];
          if ('gtmDataLayer' in window && data.entityId) {
            gtmDataLayer.push({
              event: 'popupPhotoGallaryEntityChanged',
              entityType: 'photo',
              entityId: data.entityId,
            });
          }
          if (data.url) {
            history.replaceState({}, null, data.url);
            hitPageView(data.url);            
          } else {
            var pageLocation = $galleryList.data('page-location');
            if (pageLocation) {
              history.replaceState({}, null, pageLocation);
            }
          }

          if (data.adSlide) {

            if ('gtmDataLayer' in window) {
              gtmDataLayer.push({
                event: 'popupPhotoGallaryCustomSlideAds',
              });
            }

            const stroerInitEvent = new Event('stroerInitInGallery');
            document.dispatchEvent(stroerInitEvent);

            var el = $('.lg-inner .lg-current .lg-custom-ads');
            banners(el);
            
          }
        }
      }
    })
    .on('onCustomContentReady.lg', function(event, $container) {
      // stop propagation of scroll and swipe
      // to allow scrolling of inner content
      $container
        .find('.lg-custom-content_column')
        .on('mousewheel touchstart touchmove', function(event) {
          event.stopPropagation();
        });
    })
    .on('onBeforeClose.lg', function() {
      if ($galleryList.data('ampphotoid')) {
        $galleryList.removeAttr('data-ampphotoid data-ampgalleryid');
        $galleryList.removeData('ampphotoid data-ampgalleryid');
      }

      var pageLocation = $galleryList.data('page-location');
      if (pageLocation) {
        // if($galleryList.data('slider-hash')){
        //     var lightGalleryCore = $(this).data('lightGallery');
        //     if('index' in lightGalleryCore){
        //         var $currentSlide = $(lightGalleryCore.$items[lightGalleryCore.index]);
        //         if($currentSlide.length){
        //             var h = $currentSlide.data('hash');
        //             if(h){
        //                 var $mainPhoto = $(selector).find('.msnt-photo-thumb-gallery-main-photo-box');
        //                 var $mainPhotoImage = $mainPhoto.find('img');
        //                 var src = $currentSlide.data('src');
        //                 var href = $currentSlide.data('url');
        //                 if($mainPhoto.length && $mainPhotoImage.length && src && href){
        //                     var slide_hash = '#' + h;
        //                     $galleryList.goToSlide(lightGalleryCore.index);
        //                     $mainPhoto.attr('href', href);
        //                     $mainPhotoImage.attr('src', src);
        //                     history.replaceState({}, null, pageLocation + slide_hash);
        //                 }
        //             }else{
        //                 history.replaceState({}, null, pageLocation);
        //             }
        //         }
        //     }
        // }else{
        // }
        history.replaceState({}, null, pageLocation);
      }

      $galleryList.data('full-size', false);
    })
    .on('onCloseAfter.lg', function() {
      if(!options.singleLoad) {
        $galleryList
        .off(
          'onAfterSlide.lg onCustomContentReady.lg onBeforeClose.lg onCloseAfter.lg'
        )
        .data('lightGallery')
        .destroy(true);
      }
      disableScroll('destroy');
      window.successResponse = true;
    });
}